import { Card, HighlightedCard } from '@edreamsodigeo/prisma-design-system';
import { useFlowTools } from 'flowTools/useFlowTools';
import { usePrime } from 'clientState/providers/PrimeProvider';
import React from 'react';
import { DealCard } from '../Deals/DealCard';
import {
  DEAL_WEEKEND,
  DEAL_HOTTEST,
} from 'clientState/hooks/useGetBuyPathDeal';

const getSemanticType = (highlightedType) => {
  if (
    highlightedType === 'recommended' ||
    highlightedType === DEAL_WEEKEND ||
    highlightedType === DEAL_HOTTEST
  ) {
    return 'positive';
  } else if (
    highlightedType === 'metaSelection' ||
    highlightedType === 'personalised'
  ) {
    return 'branded';
  }
  return '';
};

export const ItineraryCard = ({ children, highlightedType, ...props }) => {
  const type = getSemanticType(highlightedType);
  const { isDesktop } = useFlowTools();
  const { isUK, isPrimeUser, isPrimeSite } = usePrime();

  const withUKStyle = isUK && !isPrimeUser && isPrimeSite;
  const spaces = isDesktop ? { p: 0 } : {};
  const PromotedCard =
    highlightedType === DEAL_WEEKEND || highlightedType === DEAL_HOTTEST
      ? DealCard
      : HighlightedCard;

  return type ? (
    <>
      <PromotedCard
        type={type}
        {...spaces}
        {...props}
        p={isDesktop || withUKStyle ? '0' : 'base'}
      >
        {children}
      </PromotedCard>
    </>
  ) : (
    <Card {...props} {...spaces}>
      {children}
    </Card>
  );
};
